module.exports = __webpack_public_path__ + "static/media/aircon.3625df88.svg";